// extracted by mini-css-extract-plugin
export default {"wrapper":"MessagesList_wrapper__IS8Y8","messagesWrapper":"MessagesList_messagesWrapper__ys9XC","messages":"MessagesList_messages__ERfRP","logoBlock":"MessagesList_logoBlock__mFzby"};